import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4a826cd7")

_pushScopeId("data-v-4a826cd7")
const _hoisted_1 = {
  key: 9,
  class: "pw-player-controls player-adon"
}
const _hoisted_2 = { class: "flex-box" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { style: {"flex-grow":"1 !important"} }, null, -1)
const _hoisted_4 = {
  key: 12,
  class: "pw-player-container",
  ref: "shaka_container"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CtaOverlayComponent = _resolveComponent("CtaOverlayComponent")
  const _component_LogoOverlayComponent = _resolveComponent("LogoOverlayComponent")
  const _component_DemoOverlayComponent = _resolveComponent("DemoOverlayComponent")
  const _component_VideoLoadingComponent = _resolveComponent("VideoLoadingComponent")
  const _component_ContinuePlayComponent = _resolveComponent("ContinuePlayComponent")
  const _component_CtaContinueButton = _resolveComponent("CtaContinueButton")
  const _component_VideoErrorComponent = _resolveComponent("VideoErrorComponent")
  const _component_PlayButtonComponent = _resolveComponent("PlayButtonComponent")
  const _component_LoadingIcon = _resolveComponent("LoadingIcon")
  const _component_PosterCaptionsMenuComponent = _resolveComponent("PosterCaptionsMenuComponent")
  const _component_PosterComponent = _resolveComponent("PosterComponent")
  const _component_SeekbarComponent = _resolveComponent("SeekbarComponent")
  const _component_ControlsLeftComponent = _resolveComponent("ControlsLeftComponent")
  const _component_ControlsRightComponent = _resolveComponent("ControlsRightComponent")
  const _component_CaptionsComponent = _resolveComponent("CaptionsComponent")
  const _component_PlayerJsAdapter = _resolveComponent("PlayerJsAdapter")
  const _component_LightboxPosterComponent = _resolveComponent("LightboxPosterComponent")

  return (_openBlock(), _createBlock("div", {
    class: _ctx.dimentionHandlerObj.containerClassList.value,
    style: {
      width: '100% !important',
      minHeight: _ctx.dimentionHandlerObj.height.value + 'px !important'
    },
    onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showControls = true)),
    onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showControls = _ctx.isplaying ? false : true)),
    ref: "playerContainer"
  }, [
    (_ctx.cta)
      ? (_openBlock(), _createBlock(_component_CtaOverlayComponent, {
          key: 0,
          isPosterVisible: _ctx.getisPosterVisible(),
          cta: _ctx.cta,
          currentTime: _ctx.durationObj.currentTime,
          dur: _ctx.durationObj.dur,
          continuefromTime: _ctx.video_type == _ctx.videoType ? _ctx.continuefromTime : 0,
          hasEnded: _ctx.getHasEnded()
        }, null, 8, ["isPosterVisible", "cta", "currentTime", "dur", "continuefromTime", "hasEnded"]))
      : _createCommentVNode("", true),
    (_ctx.logoOverlay?.url)
      ? (_openBlock(), _createBlock(_component_LogoOverlayComponent, {
          key: 1,
          logoUrl: _ctx.logoOverlay?.url,
          colorScheme: _ctx.logoOverlay?.color_scheme,
          cta: !!_ctx.cta,
          isPosterVisible: _ctx.getisPosterVisible(),
          dur: _ctx.durationObj.dur,
          duration: _ctx.duration,
          continuefromTime: _ctx.continuefromTime,
          hasEnded: _ctx.getHasEnded()
        }, null, 8, ["logoUrl", "colorScheme", "cta", "isPosterVisible", "dur", "duration", "continuefromTime", "hasEnded"]))
      : _createCommentVNode("", true),
    _createVNode(_component_DemoOverlayComponent, { useDemoOverlay: _ctx.useDemoOverlay }, null, 8, ["useDemoOverlay"]),
    (_ctx.isLoading && _ctx.usetheaterMode == false)
      ? (_openBlock(), _createBlock(_component_VideoLoadingComponent, {
          key: 2,
          isLoadingFullVideo: _ctx.isFullVideoLoading
        }, null, 8, ["isLoadingFullVideo"]))
      : _createCommentVNode("", true),
    (_ctx.usetheaterMode == false && _ctx.post_play == _ctx.Postplay.CONTINUE_PLAY)
      ? (_openBlock(), _createBlock(_component_ContinuePlayComponent, {
          key: 3,
          continuefromTime: _ctx.video_type == _ctx.videoType ? _ctx.continuefromTime : 0,
          dur: _ctx.durationObj.dur,
          updateWithFullVideo: _ctx.updateWithFullVideo,
          hasEnded: _ctx.getHasEnded()
        }, null, 8, ["continuefromTime", "dur", "updateWithFullVideo", "hasEnded"]))
      : _createCommentVNode("", true),
    (!(_ctx.video_type == _ctx.videoType ? _ctx.continuefromTime : 0) && !!_ctx.cta)
      ? (_openBlock(), _createBlock(_component_CtaContinueButton, {
          key: 4,
          dur: _ctx.durationObj.dur,
          hasEnded: _ctx.getHasEnded(),
          cta: _ctx.cta
        }, null, 8, ["dur", "hasEnded", "cta"]))
      : _createCommentVNode("", true),
    (_ctx.usetheaterMode == false)
      ? (_openBlock(), _createBlock(_component_VideoErrorComponent, {
          key: 5,
          videoUrls: _ctx.getVideoUrls(),
          videoPlaybackError: _ctx.getvideoPlaybackError()
        }, null, 8, ["videoUrls", "videoPlaybackError"]))
      : _createCommentVNode("", true),
    (!_ctx.isMALoading && !_ctx.autoPlay)
      ? (_openBlock(), _createBlock(_component_PlayButtonComponent, {
          key: 6,
          play: _ctx.play,
          isPosterVisible: _ctx.getisPosterVisible(),
          totalDuration: _ctx.durationObj.totalDurationString.value,
          isTrailer: _ctx.isTrailer,
          title: _ctx.title ?? _ctx.videoType
        }, null, 8, ["play", "isPosterVisible", "totalDuration", "isTrailer", "title"]))
      : _createCommentVNode("", true),
    ((_ctx.isMALoading || !!_ctx.autoPlay) && _ctx.isPosterVisible == true)
      ? (_openBlock(), _createBlock(_component_LoadingIcon, { key: 7 }))
      : _createCommentVNode("", true),
    (!_ctx.autoPlay)
      ? (_openBlock(), _createBlock(_component_PosterCaptionsMenuComponent, {
          key: 8,
          isPosterVisible: _ctx.getisPosterVisible(),
          clickCaption: _ctx.clickCaption,
          subtitleArray: _ctx.captionObj.subtitleArray
        }, null, 8, ["isPosterVisible", "clickCaption", "subtitleArray"]))
      : _createCommentVNode("", true),
    _createVNode(_component_PosterComponent, {
      isPosterVisible: _ctx.getisPosterVisible(),
      poster_url: _ctx.videoUrls.poster_url,
      poster_urls: _ctx.videoUrls.poster_urls,
      play: _ctx.play
    }, null, 8, ["isPosterVisible", "poster_url", "poster_urls", "play"]),
    (_ctx.usetheaterMode == false)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", {
            class: "player-bottom-container",
            ref: "playerBottomController",
            style: {
          display: _ctx.showControls ? 'flex' : 'none' + `!important`,
          visibility: !_ctx.isPosterVisible ? 'visible' : 'hidden' + ' !important'
        }
          }, [
            _createVNode(_component_SeekbarComponent, {
              durationString: _ctx.durationObj.durationString,
              seekbarCss: _ctx.seekbarObj.seekbarCss,
              totalDurationString: _ctx.durationObj.totalDurationString,
              play: _ctx.play,
              pause: _ctx.pause,
              currentTime: _ctx.durationObj.currentTime,
              dur: _ctx.durationObj.dur,
              video: _ctx.getVideo(),
              IS_IOS: _ctx.IS_IOS
            }, null, 8, ["durationString", "seekbarCss", "totalDurationString", "play", "pause", "currentTime", "dur", "video", "IS_IOS"]),
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_ControlsLeftComponent, {
                playbtnString: _ctx.getPlayButtonStringRef(),
                togglePlay: _ctx.togglePlay,
                isPlaying: _ctx.getIsPlaying(),
                mediaElm: _ctx.getVideo(),
                IS_IOS: _ctx.IS_IOS
              }, null, 8, ["playbtnString", "togglePlay", "isPlaying", "mediaElm", "IS_IOS"]),
              _hoisted_3,
              _createVNode(_component_ControlsRightComponent, {
                canUseCaptions: _ctx.getcanUseCaptions(),
                playerContainer: _ctx.getplayerContainer(),
                captionBtnString: _ctx.captionObj.captionBtnString,
                IS_IOS: _ctx.IS_IOS,
                clickCaption: _ctx.clickCaption,
                subtitleArray: _ctx.captionObj.subtitleArray,
                currentCaptions: _ctx.captionObj.currentCaptions,
                height: _ctx.dimentionHandlerObj.height,
                videoPlayer: _ctx.getVideo()
              }, null, 8, ["canUseCaptions", "playerContainer", "captionBtnString", "IS_IOS", "clickCaption", "subtitleArray", "currentCaptions", "height", "videoPlayer"])
            ])
          ], 4),
          (_ctx.canUseCaptions)
            ? (_openBlock(), _createBlock(_component_CaptionsComponent, {
                key: 0,
                captionData: _ctx.captionObj.currentCaptionData,
                currentTime: _ctx.durationObj.currentTime
              }, null, 8, ["captionData", "currentTime"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.enablePlayerjsSupport == true)
      ? (_openBlock(), _createBlock(_component_PlayerJsAdapter, {
          key: 10,
          videoEl: _ctx.getVideo()
        }, null, 8, ["videoEl"]))
      : _createCommentVNode("", true),
    (_ctx.usetheaterMode == true)
      ? (_openBlock(), _createBlock(_component_LightboxPosterComponent, {
          key: 11,
          ref: "lightboxPoster",
          poster_url: _ctx.videoUrls.poster_url,
          poster_urls: _ctx.videoUrls.poster_urls
        }, null, 8, ["poster_url", "poster_urls"]))
      : (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode("video", {
            ref: "video",
            preload: "metadata",
            class: "pw-video",
            crossorigin: "",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isplaying ? _ctx.pause() : _ctx.play()))
          }, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.subtitlesForIos, (track, i) => {
              return (_openBlock(), _createBlock("track", {
                key: i,
                src: track.web_vtt_url,
                label: _ctx.getLanguageString(track.language),
                kind: "subtitles",
                srclang: track.language,
                default: track.language == 'en' ? true : false,
                crossorigin: ""
              }, null, 8, ["src", "label", "srclang", "default"]))
            }), 128))
          ], 512)
        ], 512))
  ], 38))
})